import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useDepartments } from "@/hooks/useDepartments";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const DepartmentTabs = ({ value, onChange, prefix }) => {
  const { departments } = useDepartments();
  return (
    <Tabs value={value} onValueChange={onChange}>
      <TabsList className="rounded-full h-auto flex-wrap">
        <TabsTrigger value="all" className="rounded-full" data-testid={`${prefix}-all`}>All</TabsTrigger>
        {departments.map((d) => (
          <TabsTrigger key={d.id} value={d.name} className="rounded-full" data-testid={`${prefix}-${slug(d.name)}`}>{d.name}</TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
